<template>
  <bill-detail :remit-no="remitNo" :remit-type="remitType"></bill-detail>
</template>
<script>
  import billDetail from './billDetail.vue';
  export default {
    components: { billDetail, },
    data() {
      return {
        remitNo: '',
        remitType: '',
      }
    },
    computed: {},
    methods: {},
    created() {
      ({ remitNo: this.remitNo, remitType: this.remitType } = this.$route.query);
      console.log(this.remitNo);
    },
    beforeRouteUpdate(to, from, next) {
      ({ remitNo: this.remitNo, remitType: this.remitType } = to.query);
    },
  }
</script>